import { DateTime } from 'luxon';

export class ParkingTimeRange
{
  public startTime: DateTime;

  public endTime: DateTime;

  constructor(startTime?: DateTime) {
    this.startTime = startTime;
  }

  // TODO: translate from specific time zone time
  public get startTimeUtc(): DateTime {
    return this.startTime.toUTC();
  }

  public getDurationInMinutes(): number
  {
    return this.endTime.diff(this.startTime).toMillis() / 60000;
  }

  public doRangesCover(timeRange: ParkingTimeRange): boolean
  {
    if (this.endTime <= timeRange.startTime || this.startTime >= timeRange.endTime)
    {
        return false;
    }

    return true;
  }
}
